export const talkItemList = [
  {
    talkTitle: 'What drove us?',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: 'Hiro',
        talkContent: (
          <>
            TRIAL Group is commemorating its 40th anniversary and getting ready for the next stage. We wanted to establish a common language within the company and work to permeate its understanding. It helps us to leap toward the new stage through &quot;TRIAL&quot; and error.
          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'Looking back the process.',
    talkList: [
      {
        id: '1',
        nameColor: '#3786c7',
        name: 'Ishibashi',
        talkContent: (
          <>
            There are &quot;things to change&quot; with the times changes and &quot;things should not change&quot; as founding philosophy.
            <br />
            We put efforts in our choice of words, but most importantly we spent a lot of time distinguishing things whether we change or not.
          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'Thoughts in Words',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: 'Hiro',
        talkContent: (
          <>
            Each of our Purpose, Vision, and Values has a key message, as the Purpose expresses “Enrich every aspect of people&apos;s lives through all we do.”
            <br />
            We are not only making benefits but also putting efforts on creating a positive impact on the society and in the world through this activity. That is our raison d&apos;être.

          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'The Keyword',
    talkList: [
      {
        id: '1',
        nameColor: '#3786c7',
        name: 'Ishibashi',
        talkContent: (
          <>
            It is &quot;Practical savvy”.
            <br />
            It tells you that we value the &quot;Practical savvy&quot; as well as technology. We carefully selected the word both in Japanese and English.
          </>
        ),
      },
      {
        id: '2',
        nameColor: '#002D65',
        name: 'Hiro',
        talkContent: (
          <>
            &quot;Practical savvy&quot; describes our company&apos;s unique characteristics well. We chose the word &quot;savvy&quot; over &quot;experience&quot; because we evaluate our growth based on what we learned through TRIALs and errors.
            <br />
            It expresses the message we fearlessly take on new challenges while incorporating the latest technology.
          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'How We Penetrate Philosophy into Business',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: 'Hiro',
        talkContent: (
          <>
            It is important to act under our &quot;purpose,&quot; &quot;vision,&quot; and &quot;value&quot;. To fulfill our philosophy, we offer customers valuable shopping experiences assisted by technology.
            <br />
            Retail business and Retail AI business are sharing same goals even though their business fields are different. We can achieve our vision and value by having business synergy.
          </>
        ),
      },
      {
        id: '2',
        nameColor: '#3786c7',
        name: 'Ishibashi',
        talkContent: (
          <>
            We use our philosophy to enhance contribution for customers.
            <br />
            Day-to-day store operation is shaping tomorrow in the retail business. Awareness that every one of us have led to the future.
          </>
        ),
      },
    ],
  },
  {
    talkTitle: 'What is TRIAL business style?',
    talkList: [
      {
        id: '1',
        nameColor: '#002D65',
        name: 'Hiro',
        talkContent: (
          <>
            The word &quot;technology&quot; in the vision explains studying the distribution platform. Our purpose and vision are what we will achieve over the long term. 
            <br />
            With our global experiences, we adopted words &quot;World&quot; and &quot;Technology&quot; into our Philosophy.
          </>
        ),
      },
      {
        id: '2',
        nameColor: '#3786c7',
        name: 'Ishibashi',
        talkContent: (
          <>
            We are working onto current business and future business simultaneously.
            <br />
            We move forward both real stores and digital data at the same time. It is in our &quot;Value&quot;. This is what TRIAL is all about.
          </>
        ),
      },
    ],
  },
]
